/**
 * Text Node Extension
 * 文本节点
 */

import type { NodeSpec } from '../../core/types';
import { NodeExtension } from '../../core/Extension';

export class Text extends NodeExtension {
  get name(): string {
    return 'text';
  }

  get schema(): NodeSpec {
    return {
      group: 'inline',
    };
  }
}
